import React from 'react';
import { Link } from 'react-router-dom';

// context

// styles
import styles from "../../Meeting/Archive/MeetingsArchiveCard.module.css"

// images
import arrowForwardBlue from "../../../../assets/img/DashboardICons/ArrowLeftBlue.svg"
import clockIcon from "../../../../assets/img/DashboardICons/ClockIcon.svg"

const MyNotesCard = (props) => {
    const e2p = s => s?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])
    return (
        <>
            <div className="py-2">
                <div className={`${props.user ? "" : "container-fluid"}`}>
                    <div
                        className={`w-100 d-flex justify-content-center flex-wrap ${props.notesData == "" ? "align-items-center" : "align-items-start"} mt-3 ${props.user ? "" : "me-3"}`}
                        dir="rtl"
                        style={{ minHeight: "397px" }}
                    >
                        <div className='w-100 d-flex align-items-center justify-content-xl-between justify-content-center flex-wrap'>
                            {props.notesData == "" ?
                                <div className={`w-100 d-flex align-items-center justify-content-center ${styles.title}`}>
                                    آیتم مورد نظر یافته نشد
                                </div>
                                :
                                props.notesData?.map((item) => (
                                    <div key={item.id} className={`px-3 py-2 my-3 mx-xl-2 mx-lg-0 ${props.user ? styles.user_card_conatienr : styles.card_conatienr}`}>
                                        <Link to={{
                                            pathname: props.user ? `/user-note-detail/${item.id}` : `/note-detail/${item.id}`,
                                            state: item
                                        }} className={`w-100 d-flex align-items-center justify-conten-start mb-3 mt-3 ${styles.title}`}>
                                            {e2p(item.title?.toString())}
                                        </Link>
                                        <div className="w-100 d-flex align-items-center justify-conten-start mb-3">
                                            <img className="ms-3" src={clockIcon} alt="icon" />
                                            <div className={styles.date_info_text}>
                                                {e2p(item.createDate?.toString())}
                                            </div>
                                        </div>
                                        <div className='w-100 d-flex align-items-center justify-content-end mb-3'>
                                            <Link to={{
                                                pathname: props.user ? `/user-note-detail/${item.id}` : `/note-detail/${item.id}`,
                                                state: item
                                            }} className={`d-flex align-items-center ${styles.text_primary}`}>
                                                بیشتر
                                                <img className='me-2' width="12px" src={arrowForwardBlue} alt="icon" />
                                            </Link>
                                        </div>
                                    </div>
                                ))
                            }

                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default MyNotesCard;